import getCategories from './util/getCategories'
import getSkincareCollections from './util/getSkincareCollections'

import messages from './messages'


const getNavStructureMobile = ({ root, structure, collections }) =>
  structure.reduce((newStructure, { children, name, url: to, productsQuery: { gender } }) => {
    // ATTN we disabling third level of navigation for mobile users
    const categories = getCategories({ routes: children, withSubNav: false })
    const seeAllItem = {
      title: messages.seeAll, // for consistent with other 'see all' links
      to,
      dataTestId: name,
    }

    if (root === 'skincare') {
      const collectionsItem = getSkincareCollections({ gender, collections })

      newStructure.push(
        {
          title: gender === 'male' ? messages.men : messages.women,
          isSeparator: true,
        },
        seeAllItem,
        collectionsItem
      )
    }
    else {
      newStructure.push(seeAllItem)
    }

    newStructure.push(...categories)

    return newStructure
  }, [])


export default getNavStructureMobile
